export const setReviewsSortBy = (state, sortBy) => {
  state.sortBy = sortBy
  state.page = 1
}

export const setReviewsFilterByCountry = (state, country) => {
  state.filterByCountry = country
  state.page = 1
}

export const setSelectedCountryCodes = (state, countries) => {
  state.selectedCountryCodes = countries
  state.page = 1
}

export const setReviewsFilterByVariantIds = (state, variantIds) => {
  state.filterByVariantIds = variantIds
  state.page = 1
}

export const setSelectedVariantIds = (state, variantIds) => {
  state.selectedVariantIds = variantIds
  state.page = 1
}

export const setReviewsFilterByRating = (state, rating) => {
  state.filterByRating = rating
  state.page = 1
}

export const setSelectedRatings = (state, ratings) => {
  state.selectedRatings = ratings
  state.page = 1
}

export const setExcludeUSReviewsFilter = (state, boolean) => {
  state.excludeUSReviewsFilter = boolean
  state.page = 1
}

export const setShowMobileFilter = (state, boolean) => {
  state.showMobileFilter = boolean
}
